module.exports = __webpack_public_path__ + "img/search.3b831463.svg";